import React, { useEffect, useState, useMemo } from 'react';
import { useCollect } from 'hooks';
import { MARK_TYPES } from 'utils/Constants';

import { Button, Input, Select } from 'components/Misc/Form';

import { useUserCreateStore } from 'store/user/useUserCreateStore';

const INITIAL = {
	mark: '',
	type: '',
	subject: {
		id: 0,
		title: ''
	}
};

const Marks = ({ grade }) => {
	// Store mark's data
	const [data, setData] = useState(INITIAL);

	// Check if submit is disabled
	const isDisabled = useMemo(() => {
		return !data.mark || !data.type || !data.subject.id;
	}, [data]);

	// Use user's creation store
	const onAddStudentMark = useUserCreateStore(state => state.onAddStudentMark);

	// Store requested subjects
	const [[subjects], collect] = useCollect('subjects');

	// Handle mark data change
	const onChange = ({ name, value }) => {
		// Special case for subject selection
		if (name === 'subject') {
			const subject = subjects.find(s => s.id === +value);

			return setData(prev => ({
				...prev,
				subject: subject ? {
					id: subject.id,
					title: subject.title
				} : {
					id: 0,
					title: ''
				}
			}));
		}

		setData(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Handle mark addition for student
	const onAdd = () => {
		// Reset mark's data
		setData(INITIAL);

		// Add mark to student's data
		onAddStudentMark(grade.id, data);
	};

	// Collect subjects on mount
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	return (
		<div className="grid grid-cols-2 gap-4">
			<Select
				name="subject"
				value={data.subject.id}
				onChange={onChange}
				label="Mācību kurss"
				placeholder=" "
				options={subjects?.map(subject => ({
					value: subject.id,
					name: subject.title
				}))}
			/>

			<Select
				name="type"
				value={data.type}
				onChange={onChange}
				label="Tips"
				placeholder=" "
				options={MARK_TYPES?.map(type => ({
					value: type.value,
					name: type.text
				}))}
			/>

			<Input
				type="text"
				name="mark"
				label="Vērtējums"
				value={data.mark}
				onChange={onChange}
				className="flex-1"
			/>

			<div className="col-span-2 flex justify-end">
				<Button
					icon="check"
					theme="success"
					value="Pievienot"
					onClick={onAdd}
					disabled={isDisabled}
				/>
			</div>
		</div>
	);
};

export default Marks;